<p>Player projection</p>
<div id="ChartProjection" style="max-width: 750px;"></div>
